import { FormField, FormItem, FormLabel, FormControl, FormDescription } from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { UseFormReturn } from "react-hook-form";

interface ExpenseTypeFieldProps {
  form: UseFormReturn<any>;
  currentExpenseType: string;
  validatedAmount?: number;
}

export const ExpenseTypeField = ({ form, currentExpenseType, validatedAmount }: ExpenseTypeFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="expenseType"
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel>Source de l'argent</FormLabel>
          <FormControl>
            <RadioGroup
              onValueChange={field.onChange}
              defaultValue={field.value}
              className="flex flex-col space-y-1"
            >
              <FormItem className="flex items-center space-x-3 space-y-0">
                <FormControl>
                  <RadioGroupItem value="deducted" />
                </FormControl>
                <FormLabel className="font-normal">
                  Déduit du chiffre d'affaires
                </FormLabel>
              </FormItem>
              <FormItem className="flex items-center space-x-3 space-y-0">
                <FormControl>
                  <RadioGroupItem value="external" />
                </FormControl>
                <FormLabel className="font-normal">
                  Argent externe
                </FormLabel>
              </FormItem>
            </RadioGroup>
          </FormControl>
          {currentExpenseType === "deducted" && (
            <FormDescription>
              Chiffre d'affaires actuel: {validatedAmount?.toLocaleString()} FCFA
            </FormDescription>
          )}
        </FormItem>
      )}
    />
  );
};